module.exports = __webpack_public_path__ + "img/copy_elements.4c480991.png";